/**
 * @generated SignedSource<<158aaca39935fa668a61a1937d16c0ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserRole = "SUPER" | "ADMIN_ALL" | "ADMIN" | "JUDGE" | "CLIENT" | "SAAS_CLIENT" | "%future added value";
export type AccountSettingsPageContainer_Query$variables = {};
export type AccountSettingsPageContainer_QueryVariables = AccountSettingsPageContainer_Query$variables;
export type AccountSettingsPageContainer_Query$data = {
  readonly viewer: {
    readonly role: UserRole;
    readonly name: string | null;
    readonly company: string | null;
    readonly tel: string | null;
    readonly email: string;
    readonly itpUrls: string | null;
    readonly userTag: string | null;
    readonly isCrossDomainQuery: boolean;
    readonly isCrossDomainFragment: boolean;
    readonly jsTagManagementEnabled: boolean;
    readonly enableBackendUrlMapping: boolean;
    readonly sites: {
      readonly nodes: ReadonlyArray<{
        readonly slug: string;
      } | null> | null;
    };
  };
};
export type AccountSettingsPageContainer_QueryResponse = AccountSettingsPageContainer_Query$data;
export type AccountSettingsPageContainer_Query = {
  variables: AccountSettingsPageContainer_QueryVariables;
  response: AccountSettingsPageContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "company",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tel",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itpUrls",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userTag",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCrossDomainQuery",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCrossDomainFragment",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jsTagManagementEnabled",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableBackendUrlMapping",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountSettingsPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "SiteConnection",
            "kind": "LinkedField",
            "name": "sites",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Site",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "sites(first:1)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountSettingsPageContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": (v11/*: any*/),
            "concreteType": "SiteConnection",
            "kind": "LinkedField",
            "name": "sites",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Site",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "sites(first:1)"
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd46d01dbf1043b8d758741d8bf8de3e",
    "id": null,
    "metadata": {},
    "name": "AccountSettingsPageContainer_Query",
    "operationKind": "query",
    "text": "query AccountSettingsPageContainer_Query {\n  viewer {\n    role\n    name\n    company\n    tel\n    email\n    itpUrls\n    userTag\n    isCrossDomainQuery\n    isCrossDomainFragment\n    jsTagManagementEnabled\n    enableBackendUrlMapping\n    sites(first: 1) {\n      nodes {\n        slug\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "091e4d491d2ea03506063cd40e2a4fe9";

export default node;
